/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import Container from '@mui/material/Container';
import PageSubHeader from '../Layout/PageSubHeader'
import { useTranslation } from 'react-i18next';
import Team from "../shared/Team"

const About = () => {
  const { classes } = useStyles();
  const { t } = useTranslation()
  return (
    < >
      <PageSubHeader location={t('titles:aboutus')} />
      <Grid container spacing={4} className={classes.pageContainer}>
        <Grid item xs={12} sm={12} md={12}>
          <Container className={classes.cardGrid} maxWidth="xl">
            <Grid container maxwidth="sm" justify="center" className={classes.pageContainer} spacing={5} alignItems="stretch" >
              <Grid item xs={12} sm={6} md={6}>
                <Typography style={{ color: "#383e56", textTransform: "uppercase" }} variant="h2" align="center" color="textPrimary" gutterBottom>
                  {t('titles:aboutus')}
                </Typography>
                <div className={classes.sectionTitleBorder}></div>
                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                  {t('descp:aboutusParaOne')}
                </Typography>

                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                  {t('descp:aboutusParaTwo')}
                </Typography>

                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                  {t('descp:aboutusParaThree')}
                </Typography>

                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                  {t('descp:aboutusParaFour')}
                </Typography>

                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                  {t('descp:aboutusParaFive')}
                </Typography>

                <Typography variant="h3" style={{ lineHeight: '1.7', marginBottom: '15px' }}>
                  {t('descp:aboutusParaSix')}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6} md={6}>
                <img src="/assets/images/bg/business.jpg" alt="buisness" style={{ maxWidth: '100%', width: '100%' }} />
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} className={classes.containerDotBG} style={{ padding: '20px' }}>
              <div data-aos='fade-up' data-aos-offset="200" data-aos-easing="ease-in-sine" data-aos-duration="700">
                <Team />
              </div>
            </Grid>

          </Container>
        </Grid>
      </Grid>




    </ >
  );
}
const useStyles = makeStyles({ "name": { About } })((theme) => ({
  pageContainer: {
    padding: '1.7%',
  },

  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitleBorder: {
    width: '100px',
    height: '2px',
    marginRight: 'auto',
    marginLeft: 'auto',
    backgroundColor: '#fb743e',
    marginBottom: '30px',
  },
  title: {
    paddingTop: '20px'
  }, containerDotBG: {
    backgroundColor: '#fff!important',
    backgroundImage: 'radial-gradient(circle, #cbcbcb  20%, transparent 10%), radial-gradient(circle, #cbcbcb  20%, transparent 10%)',
    backgroundSize: '10px 10px',
    backgroundPosition: '0 0, 50px 50px'
  },
}));

export  default About;
